import React from "react";
import { hot } from "react-hot-loader/root";

import { MyBidsTable } from "components/bid_module/MyBidsTable";
import { withAppLayout } from "../../components/app_layout/AppLayout";
import { DetailsContent } from "../../components/app_layout/DetailsLayout";
import { Flex, Text } from "../../styles/utility-components";

import css from "./MyBidsPage.module.scss";

export function MyBidsPage() {
  return (
    <DetailsContent className={css.container}>
      <Flex column gap={24}>
        <Flex column gap={8}>
          <Text h2>Bid / no-bid reports</Text>
          <Text color="sysTextSecondary">Displaying all bid / no-bid reports</Text>
        </Flex>
        <MyBidsTable />
      </Flex>
    </DetailsContent>
  );
}

export default hot(withAppLayout(MyBidsPage, {}));
